export default __webpack_public_path__ + "static/media/at.67858e80.svg";